import * as yup from "yup";
export const addCitySchema = yup.object().shape({
  name: yup.string().required("من فضلك ادخل اسم المدينة "),
  is_disabled: yup.boolean(),
});
